import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Money from '../../../common/money';
import Icon, { GLYPHS } from '../../../common/icon';
import GiftCardCharge from '../containers/GiftCardCharge';
import { t } from '../../../../modules/infra/i18n';

const GiftCard = ({
  value,
  onChange,
  onSubmit,
  reset,
  hasGiftCard,
  balance,
  insufficientFunds,
  error,
  barberName,
  maxAmount,
}) => (
  <div>
    <form onSubmit={onSubmit} className="o-flexbox">
      <div className="u-position-relative u-flex-1 u-mr-">
        <input
          className="c-input c-input--white"
          value={value}
          onChange={onChange}
          disabled={hasGiftCard}
          data-automation-id="input:giftCardCode"
        />
        <button
          type="button"
          className="c-btn c-btn--blank u-inline-block u-pin-right u-mr-"
          onClick={reset}
          display-if={hasGiftCard}
        >
          <Icon glyph={GLYPHS.arrowXClose} />
        </button>
      </div>
      <button
        type="submit"
        className="c-btn c-btn--medium"
        disabled={!value || hasGiftCard}
        data-automation-id="button:validateCard"
      >
        {t('register:payment.gift_card.validate_card')}
      </button>
    </form>
    <div className="epsilon u-mt- u-co-greyish-brown o-flexbox">
      <div
        className={classnames({ 'u-co-red': insufficientFunds })}
        display-if={hasGiftCard}
      >
        {t('register:payment.gift_card.balance')}{' '}
        <b>
          <Money>{balance}</Money>
        </b>
      </div>
      <div display-if={barberName}>
        {t('register:payment.gift_card.applicable_to')} <b>{barberName}</b>
      </div>
      <div display-if={error} className="u-co-red">{error}</div>
    </div>

    <div className="u-text-center u-mt+" display-if={maxAmount > 0}>
      {t('register:payment.gift_card.charge_limit')}{' '}
      <b>
        <Money>{maxAmount}</Money>
      </b>{' '}
      {t('register:payment.gift_card.for_barber')} <b>{barberName}</b>
    </div>
    <div className="u-text-center u-mt+">
      <GiftCardCharge />
    </div>
  </div>
);
GiftCard.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  hasGiftCard: PropTypes.bool.isRequired,
  balance: PropTypes.number.isRequired,
  insufficientFunds: PropTypes.bool.isRequired,
  error: PropTypes.string.isRequired,
  barberName: PropTypes.string.isRequired,
  maxAmount: PropTypes.number.isRequired,
};

export default GiftCard;
